import { createContext, useReducer, useEffect } from 'react'
import React from 'react'

export const AuthContext = createContext()

export const authReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      return { user: action.payload }
    case 'LOGOUT':
      return { user: undefined }
    default:
      return state
  }
}

/**
 * #context
 * AuthContextProvider is a React component that provides the AuthContext to its children.
 * It is a wrapper around the useReducer hook that manages the state of the user.
 * It uses the authReducer function to manage the state of the user.
 * 
 * The AuthContextProvider component takes a single prop, children, which is the children of the component.
 * 
 * The AuthContextProvider component uses the useEffect hook to load the user from localStorage when the component mounts.
 * If the user is found in localStorage, it dispatches a 'LOGIN' action to the reducer with the user as the payload.
 * 
 * The AuthContextProvider component then returns a React Context Provider component with the state of the user and the dispatch function as the value.
 */
export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, { 
    user: undefined
  })

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'))

    if (user) {
      dispatch({ type: 'LOGIN', payload: user }) 
    }
  }, [])

  //console.log('AuthContext state:', state)
  
  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      { children }
    </AuthContext.Provider>
  )

}